import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import { appContext } from '../util/decorators';
import PlayDuration from './PlayDuration.jsx';

@appContext
export default class Thumbnail extends React.PureComponent {

  getMediaItemType(data) {
    if (!_.isEmpty(_.get(data, 'tags.blogs'))) {
      return 'blog';
    } else if (!_.isEmpty(_.get(data, 'tags.podcasts'))) {
      return 'podcast';
    }
    return '';
  }

  getContentType(data) {
    if (this.props.isCurrentlyPlayed) {
      return ['isCurrentlyPlayed'];
    }

    const video = _.get(data.videos, '[0].data');
    const isLive = video && video.beginPlaybackFrom
      && _.includes(_.get(data, 'tags.videoTypes'), 'live')
      && this.context.app.serverTime().isBetween(video.beginPlaybackFrom, video.endPlaybackAt);
    const isMediaItem = this.getMediaItemType(data);

    // Items will be prioitized in this order
    const types = {
      isLive: isLive,
      isMediaItem: isMediaItem,
      isVideo: !_.isEmpty(video),
    };

    return _.chain(types)
      .map((item, key) => { if (item) return key;})
      .compact()
      .value();
  }

  render() {
    const { t } = this.context.app;
    const { className, data, maxItems, smallRibbon } = this.props;
    const videoDuration = _.get(data.videos, '[0].data.duration');
    const contentComponents = this.getContentType(data).slice(0, maxItems || 1);
    const mediaItemType = this.getMediaItemType(data);

    return (
      <div className={cx('thumbnail', className)}>
        { this.props.children }
        {
          _.includes(contentComponents, 'isLive') &&
          <span className={cx('ribbon ribbon-live', { 'ribbon-small': smallRibbon })}>Live</span>
        }
        {
          _.includes(contentComponents, 'isMediaItem') &&
          <span className={cx('ribbon ribbon-media-item', { 'ribbon-small': smallRibbon })}>
            { this.context.app.t(`FeedContainerBig.${mediaItemType}`)}
          </span>
        }
        {
          _.includes(contentComponents, 'isVideo') &&
          <PlayDuration smallRibbon={smallRibbon} duration={videoDuration} />
        }
        {
          _.includes(contentComponents, 'isCurrentlyPlayed') &&
          <div className="currently-played">
            <span className="currently-played-ribbon">{t('Thumbnail.playing')}</span>
          </div>
        }

      </div>
    );
  }
}

Thumbnail.propTypes = {
  data: React.PropTypes.object.isRequired,
  children: React.PropTypes.object,
  className: React.PropTypes.string,
  maxItems: React.PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/component/Thumbnail.jsx